export default __webpack_public_path__ + "static/underwear-results-1-3066b5342cfdcbb0d3a02097710cf1d2.png";